import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  Legend,
} from "recharts";

const formatUnits = (value) => {
  const formatter = new Intl.NumberFormat("en-US", {
    notation: "compact",
    compactDisplay: "short",
  });
  const formattedNumber = formatter.format(value);
  return formattedNumber;
};

const formatCurrency = (value) => {
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    notation: "compact",
    compactDisplay: "short",
  });
  const formattedNumber = formatter.format(value);
  return formattedNumber;
};

const getTickFormatter = (dataType) => {
  if (dataType === "currency") {
    return formatCurrency;
  }
  return formatUnits;
};

const seriesFillColors = [
  "#0CB54F",
  "#188fff",  // TODO: Pick different colors for 3rd series
  "#bf1212",
  "#BBB024",
  "#BBB024",  // TODO: Pick different colors for 5rd series
];

export const BarChartWidget = (props) => {
  const {
    toggleRecords,
    graphData,
    maxChartElements,
    dataType,
  } = props;
  const chart = graphData[toggleRecords];
  const {data, series, xDataKey} = chart;
  const slicedData = data.slice(-maxChartElements);
  const tickFormatter = getTickFormatter(dataType)

  return (<>
    <ResponsiveContainer width="100%" height={400}>
      <BarChart
        data={slicedData}
        barGap={5}
        margin={{
          top: 20,
          right: 0,
          left: 0,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey={xDataKey} />
        <YAxis tickFormatter={tickFormatter} />
        <Tooltip formatter={tickFormatter} />
        <Legend />
        {series.map((seriesName, i) =>
          <Bar
            key={i}
            dataKey={seriesName}
            barSize={24}
            fill={seriesFillColors[i]}
            radius={[5, 5, 0, 0]}
          />
        )}
      </BarChart>
    </ResponsiveContainer>
  </>);

};
